import type React from 'react';
import Logo from 'src/components/logo';
import styles from 'src/HomePage/TopNavBar/JohnDeereLogo/JohnDeereLogoStyles';

const NavLogo: React.FC = () => {
  const classes = styles();

  return (
    <div className={classes.logoContainer}>
      <Logo height="40" style={{ maxWidth: 160, cursor: 'pointer' }} />
    </div>
  );
};

export default NavLogo;
